import { makeStyles } from '@eagleview/ev-comp-library';
import { random } from 'lodash';
import { setMonogramColor } from 'utils/app.utils';

const useStyles = makeStyles((theme) => {
  const raspberry = theme.evPalette.raspberry[400];
  const tulip = theme.evPalette.tulip[500];
  const lime = theme.evPalette.lime[400];
  const huckleberry = theme.evPalette.huckleberry[400];
  const marigold = theme.evPalette.marigold[600];
  const aloe = theme.evPalette.aloe[600];
  const monogramColours = [raspberry, tulip, lime, huckleberry, marigold, aloe];
  const colorValue = localStorage.getItem('ev_mgc');
  const monogramColour = colorValue ? window.atob(colorValue) : monogramColours[Math.floor(random(0, 1, true) * monogramColours.length)];
  setMonogramColor(monogramColour);

  return {
    container: {
      textAlign: 'center',
    },
    keyboardArrowDown: {
      color: theme.palette.common.white,
      margin: `${theme.spacing(1.5)}px ${theme.spacing(0.5)}px`,
    },
    box: {
      display: 'inline-flex',
    },
    avatarMicro: {
      fontSize: '14px',
      fontWeight: 'normal',
      display: 'inline-flex',
      width: theme.spacing(4),
      height: theme.spacing(4),
      backgroundColor: monogramColour,
      '&:hover': {
        filter: 'brightness(130%)',
      },
      '&:active': {
        filter: 'brightness(70%)',
      },
    },
    avatarSmall: {
      fontSize: '16px',
      fontWeight: 'normal',
      display: 'inline-flex',
      width: theme.spacing(5),
      height: theme.spacing(5),
      backgroundColor: monogramColour,
      '&:hover': {
        filter: 'brightness(130%)',
      },
      '&:active': {
        filter: 'brightness(70%)',
      },
    },
    avatarMedium: {
      fontSize: '16px',
      fontWeight: 'normal',
      width: theme.spacing(6),
      height: theme.spacing(6),
      backgroundColor: monogramColour,
      '&:hover': {
        filter: 'brightness(130%)',
      },
      '&:active': {
        filter: 'brightness(70%)',
      },
    },
    avatarLarge: {
      width: theme.spacing(10),
      height: theme.spacing(10),
      backgroundColor: monogramColour,
    },
    name: {
      color: theme.palette.common.white,
      marginTop: theme.spacing(1),
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
      whiteSpace: 'normal',
      overflowWrap: 'break-word',
      textTransform: 'capitalize',
    },
    guestName: {
      color: '#fff',
      padding: `${theme.spacing(1.25)}px ${theme.spacing(1.25)}px ${theme.spacing(1.25)}px`,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(22),
      fontWeight: '500',
      height: '42px',
    },
    signIntext: {
      textTransform: 'none',
    },
    nameContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      textAlign: 'center',
      overflowWrap: 'break-word',
    },
    boldText: {
      fontWeight: 'bold',
    },
    badgeContainer: {
      backgroundColor: theme.evPalette.mango[600],
      width: theme.spacing(3),
      height: theme.spacing(3),
      borderRadius: '50%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    badgeIcon: {
      fontSize: '16px',
      color: theme.evPalette.mango[700],
    },
    userMenu: {
      width: theme.spacing(20),
    },
    settingsOnSide: {
      marginLeft: theme.spacing(1),
    },
    settingsBelow: {
      marginTop: theme.spacing(0.3),
    },
    listItemIcon: {
      minWidth: theme.spacing(4),
    },
    popper: {
      zIndex: theme.zIndex.modal,
    },
    signOutIcon: {
      width: theme.spacing(3),
      marginTop: theme.spacing(0.5),
    },
    listStyle: {
      alignItems: 'start',
      gap: theme.spacing(0.5),
      '&:hover': {
        backgroundColor: theme.evPalette.charcoal[100],
        cursor: 'pointer',
      },
    },
    signOutText: {
      whiteSpace: 'normal',
      overflowWrap: 'break-word',
      textAlign: 'left',
      marginRight: theme.spacing(1),
    },
    capitalize: {
      textTransform: 'capitalize',
    },
  };
});

export default useStyles;
